import { render, staticRenderFns } from "./ChannelIndex.vue?vue&type=template&id=6b1fd7fc&scoped=true&"
import script from "./ChannelIndex.vue?vue&type=script&lang=js&"
export * from "./ChannelIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1fd7fc",
  null
  
)

export default component.exports